var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-review-popup',{attrs:{"visible":_vm.visible,"title":_vm.$t('registration.client.info.terms.of.use')},on:{"close":_vm.toggleAgreementDataPopup}},[_c('template',{slot:"message"},[_c('paragraph-list',{attrs:{"headers":_vm.popupHeaders,"paragraphs":_vm.popupParagraphs}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }